import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews } from "@/lib/video";

interface VideoCardProps {
  video: Video;
  categoryName?: string;
}

export default function VideoCard({ video, categoryName }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 逼特逼视频`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/75 px-1.5 py-0.5 text-xs font-label text-background-50">
          {video.duration}
        </span>
        {categoryName && (
          <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs text-background-50">
            {categoryName}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {video.title}
        </h3>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
          <span className="truncate">{video.author}</span>
          <span className="text-foreground-300">·</span>
          <span className="whitespace-nowrap">{video.uploadDate}</span>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          {video.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
          <span className="ml-auto flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
            <i className="ri-play-circle-line text-sm" />
            {formatViews(video.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}